export const selectMachinesList = (state) => state.machine.items
export const selectIsFetchingMachinesList = (state) => state.machine.isFetchingMachinesList
export const selectMachinesListTotal = (state) => state.machine.totalCount

export const selectMachineActionStatus = (state) => state.machine.actionStatus
